export const appPagePaths = {
  root: '/',
  home: '/',
  logout: '/logout',
  signUp: '/sign-up',
  authorization: '/authorization',
  organizations: '/organizations',
  municipalities: '/municipalities',
  regions: '/user-regions',
  region: '/user-regions/:regionId',
  users: '/users',
  buildings: '/buildings',
  building: '/buildings/:buildingId',
  educationClasses: '/education-classes',
  educationClass: '/education-classes/:educationClassId',
  academicCalendar: '/academic-calendar',
  productionCalendar: '/production-calendar',
  educationPlans: '/education-plans',
  educationPlan: '/education-plans/:educationPlanId',
  teacherWorkloads: '/teacher-workloads',
  teacherWorkload: '/teacher-workloads/:teacherWorkloadId',
  classGroups: '/class-groups',
  subjectDifficulties: '/subject-difficulties',
  scheduleForWeek: '/schedule-for-week',
  scheduleConfigurationForm: '/schedule-for-week/configuration',
  configurationSchedules: '/schedule-for-week/:configurationId',
  schedule: '/schedule-for-week/:configurationId/:scheduleId',
  educationPlanOop: '/education-plan/:educationPlanId',
  bellSchedules: '/bell-schedules',
  maxLessonsPerDay: '/max-lessons-per-day',
};

export const appRouterPaths = {
  root: '/',
  home: '/',
  logout: '/logout',
  signUp: '/sign-up',
  authorization: '/authorization',
  organizations: '/organizations',
  municipalities: '/municipalities',
  regions: '/user-regions',
  region: '/user-regions/:regionId',
  buildings: '/buildings',
  building: '/buildings/:buildingId',
  educationClasses: '/education-classes',
  educationClass: '/education-classes/:educationClassId',
  academicCalendar: '/academic-calendar',
  productionCalendar: '/production-calendar',
  educationPlans: '/education-plans',
  educationPlan: '/education-plans/:educationPlanId',
  teacherWorkloads: '/teacher-workloads',
  teacherWorkload: '/teacher-workloads/:teacherWorkloadId',
  classGroups: '/class-groups',
  subjectDifficulties: '/subject-difficulties',
  scheduleForWeek: '/schedule-for-week',
  scheduleConfigurationForm: '/schedule-for-week/configuration',
  configurationSchedules: '/schedule-for-week/:configurationId',
  schedule: '/schedule-for-week/:configurationId/:scheduleId',
  educationPlanOop: '/education-plan/:educationPlanId',
  bellSchedules: '/bell-schedules',
  maxLessonsPerDay: '/max-lessons-per-day',
};
